import { combineReducers } from '@reduxjs/toolkit';
import goalsReducer from './features/goals/goalSlice';
import filtersReducer from './features/goals/filterSlice';
import favouritesReducer from './features/goals/favouriteSlice';
import studentReducer from './features/students/studentSlice';
import classReducer from './features/students/classSlice';
import ratingReducer from './features/ratings/ratingSlice';

const rootReducer = combineReducers({
  goals: goalsReducer,
  filters: filtersReducer,
  favourites: favouritesReducer,
  students: studentReducer,
  classes: classReducer,
  ratings: ratingReducer,
});
export default rootReducer;
